import React, { FC } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { OrganizationContact } from 'models/contact';
import FormattedAddress from 'components/shared/address/formatted-address.component';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';

type LabContactDetailsProps = {
    contact: OrganizationContact;
};
const LabContactDetails: FC<LabContactDetailsProps> = ({ contact }) => {
    const siteUrlWithProtocol = (url: string) =>
        url.startsWith('http://') || url.startsWith('https://') ? url : `http://${url}`;

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <BusinessIcon sx={{ fontSize: '1rem', color: 'text.secondary', mt: 0.25, flexShrink: 0 }} />
                <Box>
                    <FormattedAddress address={contact?.address} />
                </Box>
            </Box>
            {contact?.communication?.phone && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LocalPhoneIcon sx={{ fontSize: '1rem', color: 'text.secondary', flexShrink: 0 }} />
                    <Typography variant="body2">{contact.communication.phone}</Typography>
                </Box>
            )}

            {contact?.communication?.email && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <EmailIcon sx={{ fontSize: '1rem', color: 'text.secondary', flexShrink: 0 }} />
                    <Typography variant="body2">{contact.communication.email}</Typography>
                </Box>
            )}

            {contact?.communication?.site && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LanguageIcon sx={{ fontSize: '1rem', color: 'text.secondary', flexShrink: 0 }} />
                    <Link variant="body2" href={siteUrlWithProtocol(contact.communication.site)} target="_blank">
                        {contact.communication.site}
                    </Link>
                </Box>
            )}
        </>
    );
};

export default LabContactDetails;
